<template>
    <div>
        <div class="modal fade" id="mdltarefa">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" style="float: right; margin-right: 5px;">
                <div class="modal-content">
                    <div class="modal-header" style="padding-right: 0px;">
                        <div class="row" style="width: 100%;">
                            <div class="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8" style="min-height: 36px;">
                                <h4 v-if="parseInt(optarefa) === 0 && titulotarefa === ''" class="modal-title">Nova tarefa</h4>
                                <h4 v-else class="modal-title">{{ titulotarefa }}</h4>
                            </div>
                            <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-right" style="padding-right: 25px;">
                                <button v-if="parseInt(optarefa) === 1"      @click.prevent="mtdfinalizartarefa()" type="button" class="btn btn-success btn-sm" style="margin-top: 3px; border-radius: 15px;"><i class="fa fa-check-circle"></i> Finalizar</button>
                                <button v-else-if="parseInt(optarefa) === 2" @click.prevent="mtdreativartarefa()"     type="button" class="btn btn-info btn-sm"    style="margin-top: 3px; border-radius: 15px;"><i class="fa fa-undo"        ></i> Reativar</button>
                            </div>
                            <button type="button" class="close" data-dismiss="modal" style="float: right; margin-top: -58px;">&times;</button>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-8">
                                <div class="row">
                                    <div class="col-md-8">
                                        <label for="edtitulotarefa">Título da tarefa:</label>
                                        <input type="text" v-model="titulotarefa" class="form-control form-control-sm" id="edtitulotarefa" v-bind:disabled="parseInt(optarefa) === 2" data-bv-group=".group" maxlength="100">
                                    </div>
                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                        <label for="eddttarefa">Data:</label>
                                        <div class="input-group">
                                            <date-picker id="eddttarefa" v-model="dttarefa" :config="options" 
                                                class="form-control form-control-sm" v-bind:disabled="parseInt(optarefa) === 2">
                                            </date-picker>
                                            <div class="input-group-append">
                                                <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                            </div>                                            
                                        </div>
                                    </div>                                    
                                    <div class="col-md-12" style="margin-bottom: 15px;">
                                        <label for="txtdescritivotarefa">Detalhes:</label>
                                        <textarea class="form-control center" rows="4" id="txtdescritivotarefa" v-model="descritivotarefa" style="font-size: 14px;" v-bind:disabled="parseInt(optarefa) === 2"></textarea>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <h6 style="color: #666;font-weight: 700; font-size: 14px;">Checklist</h6>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <ul class="list-group">
                                                            <li v-for="(item, index) in checklist" :key="index" class="optask-list list-group-item list-group-item-action">
                                                                <div class="row">
                                                                    <div v-if="parseInt(optarefa) === 1" class="col-1 col-xl-1 col-md-1 col-sm-1 col-lg-1">
                                                                        <template v-if="parseInt(optarefa) === 1">
                                                                            <span v-if="parseInt(item.finalizado) === 0" @click.prevent="mtdsituacaoitemchecklist(index)"><i class="fa fa-circle-o" style="color: #57AEF1; font-size: 22px;"></i></span>
                                                                            <span v-else @click.prevent="mtdsituacaoitemchecklist(index)"><i class="fa fa-check-circle" style="color: #57AEF1; font-size: 22px;"></i></span>
                                                                        </template>
                                                                    </div>
                                                                    <template v-if="parseInt(optarefa) === 1">
                                                                        <div v-if="parseInt(item.edicao) === 0" class="col-8 col-xl-9 col-md-7 col-sm-8 col-lg-9">
                                                                            <h6 class="tit-checklist" v-bind:style="[parseInt(item.finalizado) === 1 ? { 'text-decoration' : 'line-through' } : { 'text-decoration' : 'none' }]">{{ item.descricao }}</h6>
                                                                        </div>
                                                                        <div v-else class="col-8 col-xl-9 col-md-7 col-sm-8 col-lg-9">
                                                                            <textarea rows="5" v-model="item.descricao" id="edchecklist"></textarea>
                                                                        </div>
                                                                    </template>
                                                                    <template v-else>
                                                                        <div v-if="parseInt(item.edicao) === 0" class="col-9 col-xl-10 col-md-8 col-sm-9 col-lg-10">
                                                                            <h6 class="tit-checklist" v-bind:style="[parseInt(item.finalizado) === 1 ? { 'text-decoration' : 'line-through' } : { 'text-decoration' : 'none' }]">{{ item.descricao }}</h6>
                                                                        </div>
                                                                        <div v-else class="col-9 col-xl-10 col-md-8 col-sm-9 col-lg-10">
                                                                            <textarea rows="1" v-model="item.descricao" id="edchecklist"></textarea>
                                                                        </div>
                                                                    </template>                                                                    
                                                                    <template>
                                                                        <div v-if="parseInt(optarefa) < 2" class="col-1 col-xl-1 col-md-1 col-sm-1 col-lg-1">
                                                                            <i v-if="parseInt(item.edicao) === 0" @click.prevent="mtdeditaritemchecklist(index)" class="fa fa-edit bt-op-tarefa" style="padding-left: 0px;"></i>
                                                                        </div>
                                                                    </template>
                                                                    <template>
                                                                        <div v-if="parseInt(optarefa) < 2" class="col-1 col-xl-1 col-md-1 col-sm-1 col-lg-1" style="padding-left: 25px;">
                                                                            <i v-if="parseInt(item.edicao) === 0" @click.prevent="mtdexcluiritemchecklist(index)" class="fa fa-close bt-exc-tarefa"></i>
                                                                        </div>
                                                                    </template>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div v-if="parseInt(optarefa) < 2" class="col-md-12" style="margin-top: 10px; margin-bottom: 5px;">
                                                        <a href="#" class="link-add" @click.prevent="mtdadicionaritemchecklist()">+ Adicionar ítem à checklist</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 border-left">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h6 style="color: #666;font-weight: 700; font-size: 14px;">
                                            Participantes 
                                            <template v-if="parseInt(optarefa) < 2">
                                                <button v-if="parseInt(oplstusuario) === 0" type="button" @click.prevent="mtdlistartodosusuarios()" class="btn btn-green btn-sm btn-participantes" title="Listar todos os usuários"><i class="fa fa-users"></i></button>
                                                <button v-else type="button" @click.prevent="mtdusuariostarefa(lsttodosusuarios)" class="btn btn-green btn-sm btn-participantes" title="Listar os usuários da tarefa"><i class="fa fa-user"></i></button>
                                            </template>
                                        </h6>
                                    </div>
                                    <div class="col-md-12" style="margin-bottom: 10px;">
                                        <ul class="list-group">
                                            <li v-for="(usuario, index) in lstusuarios" :key="index" @click.prevent="mtdmarcarusuario(index)" class="optask-list list-group-item d-flex justify-content-between align-items-center list-group-item-action">
                                                <span><img class="img-usutarefa" v-bind:src="pathfotos+usuario.foto"><span class="nomeusulist">{{ usuario.nomeusu }}</span></span>
                                                <span v-if="parseInt(usuario.marcado) === 1"><i class="fa fa-check-circle" style="color: #57AEF1;"></i></span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div v-if="lstarquivostarefa.length > 0" class="col-md-12">
                                                <h6 style="color: #666;">Arquivos</h6>
                                            </div>
                                            <div v-if="lstarquivostarefa.length > 0" class="col-md-12">
                                                <div class="card">
                                                    <div class="card-body" style="padding: 2px; min-height: 40px;">
                                                        <div class="row text-center" style="padding: 15px;">
                                                            <div v-for="(arquivo, indice) in lstarquivostarefa" :key="indice" class="col-md-4 dv-arq-lista">
                                                                <div class="row">
                                                                    <div class="col-md-12">
                                                                        <a v-bind:href="patharquivos+arquivo.patharquivo" target="_blank">
                                                                            <i class="fa fa-file-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                                            <i v-if="parseInt(optarefa) < 2" class="fa fa-close icon-del-arquivo" @click.prevent="mtddeletararquivo(arquivo.patharquivo, arquivo.arquivo)" title="Excluir arquivo"></i>
                                                                        </a>
                                                                    </div>
                                                                    <div class="col-md-12">
                                                                        <a class="link-arquivo" v-bind:href="patharquivos+arquivo.patharquivo" target="_blank"><h6 class="tit-arquivo">{{ arquivo.arquivo }}</h6></a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="parseInt(optarefa) < 2" class="col-md-12 text-center" style="margin-top: 10px;">
                                                <input type="file" id="btenviararquivotarefa" style="display: none;" @change="mtdenviararquivo()">
                                                <button type="button" @click.prevent="mtddisparabtenviarquivotarefa()" class="btn btn-info btn-sm" style="color: white; margin-top: 3px; border-radius: 15px;"><i class="fa fa-upload"></i> Enviar arquivo</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div v-if="parseInt(optarefa) === 1" class="col-md-12" style="margin-bottom: 10px;">
                                <div class="row">
                                    <div class="col-md-12" style="margin-bottom: 15px;">
                                        <textarea class="form-control center" rows="3" id="txtcomentario" v-model="comentario" style="font-size: 14px;" placeholder="Adicionar comentário"></textarea>
                                    </div>
                                    <div class="col-md-12 text-right">
                                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdenviarcomentario()" style="border-radius: 15px;"><i class="fa fa-paper-plane"></i> Enviar comentário</button>
                                    </div>
                                </div>
                            </div>                            
                            <div class="col-md-12" style="margin-top: 10px;">
                                <ul class="list-group">
                                    <li v-for="(atividade, indice) in lstatividadestarefa" :key="indice" class="list-group-item list-group-item-action" style="padding: 4px;">
                                        <div class="row">
                                            <div class="col-1 col-sm-1 col-md-1">
                                                <img v-if="parseInt(atividade.tpatividade) === 13" v-bind:src="pathfotos+atividade.foto" class="img-usutarefa" style="margin: 50%;">
                                                <i v-else-if="parseInt(atividade.tpatividade) === 14" class="fa fa-undo icone-atividade" style="color: #6aa8ea;"></i>
                                                <i v-else-if="parseInt(atividade.tpatividade) === 15" class="fa fa-upload icone-atividade" style="color: #6aa8ea;"></i>
                                                <i v-else-if="parseInt(atividade.tpatividade) === 16" class="fa fa-times-circle icone-atividade" style="color: #E07856;"></i>
                                                <i v-else class="fa fa-clock-o icone-atividade" style="color: #3DCC3D;"></i>
                                            </div>
                                            <div class="col-11 col-sm-11 col-md-11">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <h6 class="det-dthratividade">{{ mtdformadardataextenso(mtdtransformadata(atividade.dthratividade+'T00:00:00'), true) }}</h6>
                                                        <i v-if="parseInt(atividade.tpatividade) === 4" data-toggle="tooltip" v-bind:title="'Texto do detalhe anterior: '+atividade.mensagem" class="fa fa-info-circle close" style="color: #a2a2a2; font-size: 14px; position: absolute; margin-left: 90%; z-index: 99;"></i>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <h6 class="tit-atividade">{{ atividade.nomeusu }}</h6>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <template v-if="parseInt(atividade.tpatividade) === 8">
                                                            <h6 class="det-atividade">{{ atividade.descricao1 }}, {{ atividade.descricao2 }} > {{ atividade.descitem }}</h6>
                                                        </template>
                                                        <template v-else-if="parseInt(atividade.tpatividade) === 5 || parseInt(atividade.tpatividade) === 6 || parseInt(atividade.tpatividade) === 7 || parseInt(atividade.tpatividade) === 9 || parseInt(atividade.tpatividade) === 10 || parseInt(atividade.tpatividade) === 11">
                                                            <h6 class="det-atividade">{{ atividade.descricao1 }} > {{ atividade.descitem }}</h6>
                                                        </template>

                                                        <template v-else>
                                                            <h6 v-if="atividade.descricao2 !== ''" class="det-atividade">{{ atividade.descricao1 }} > {{ atividade.descricao2 }}</h6>
                                                            <h6 v-else class="det-atividade">{{ atividade.descricao1 }}</h6>
                                                        </template>
                                                    </div>
                                                    <div v-if="parseInt(atividade.tpatividade) === 13" class="col-md-12" style="margin-bottom: 2px;">
                                                        <div class="card card-comentario" style="margin-top: 5px;">
                                                            <div class="card-body" style="padding: 10px;">
                                                                <div class="row">
                                                                    <div class="col-md-12">
                                                                        <span class="corpo-comentario">{{ atividade.mensagem }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>                            
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button v-if="parseInt(optarefa) === 0" type="button" class="btn btn-primary btn-sm" style="width: 100px; border-radius: 15px;" @click.prevent="mtdincluirtarefa()"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px; border-radius: 15px;"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>
<script>
import util from '../utilitarios/util.js';
export default {
    name : "cmprotinastarefa",
    components: {
    },
    props:[		
        'optarefacmp',
        'idtarefacmp'
    ],
    data () {
        return {
            pathfotos           : this.$store.state.configpaths.pathimagens,
            patharquivos        : this.$store.state.configpaths.patharquivos,
            pathtarefas         : this.$store.state.configpaths.pathtarefas,//diretório dos arquivos das tarefas
            optarefa            : 0,
            idtarefa            : '',        
            titulotarefa        : '',
            dttarefa            : util.DataAtual(true),
            descritivotarefa    : '',
            comentario          : '',
            oplstusuario        : 0,//0 - Somente os usuários das tarefas, 1 - Todos os usuários
            lstusuarios         : [],
            lsttodosusuarios    : [],
            idchecklist         : 0,
            checklist           : [],
            lstatividadestarefa : [],
            lstarquivostarefa   : [],

            //variáveis para envio dos arquivos
            diretoriotarefa     : '',
            arqselecionado      : null,

            edicaoitemchecklist : false,
            descolditemchecklist: '',

            indited             : 0,
            tarefaold           : [],
            dttarefaold         : '',            
            options: {
                format           : 'DD/MM/YYYY',
                useCurrent       : false,
                locale           : 'pt-BR'
            }            
        }
    },
    methods:{        
        mtdformadardataextenso(data, mostrahr) {
            if (!mostrahr) {
                return util.dataextenso(util.InverterData(data) + 'T00:00:00');
            }else{
                let vdthr = data.split('T');
                let vhr   = vdthr[1].split(':');
                return util.dataextenso(util.InverterData(data) + 'T00:00:00')+' às '+vhr[0]+':'+vhr[1];
            }
        },       
        mtdtransformadata: function(dttrasnf){
            return util.formatadatahrdb(dttrasnf);
        },         
        mtdativametodostext(){
            let vself = this;
            $("#edchecklist").blur(function(){
                if (vself.checklist[vself.indited].descricao.trim() === ''){
                    vself.checklist.splice(vself.indited, 1);
                }else{
                    let tpat   = 0;
                    let texto1 = '';
                    let texto2 = '';
                    vself.checklist[vself.indited].edicao = 0;
                    if (!vself.edicaoitemchecklist){
                        tpat  = 7;
                        texto1 = 'Adicionou item à Checklist';
                    }else{
                        texto1 = 'Alterou item da Checklist';
                        texto2 = vself.descolditemchecklist;
                        tpat = 8;
                    }
                    if (parseInt(vself.optarefa) === 1) {
                        let participantes = [];
                        for (let i = 0; i < vself.lstusuarios.length; ++i) {
                            if (parseInt(vself.lstusuarios[i].marcado) === 1) {
                                let participante = {
                                    'idusuario' : vself.lstusuarios[i].idusuario,
                                    'emailusu'  : vself.lstusuarios[i].emailusu
                                };
                                participantes.push(participante);
                            }
                        }
                        vself.mtdregistraratividade(vself.tarefaold.id, tpat,
                                                    texto1,
                                                    texto2, vself.checklist[vself.indited].id,
                                                    vself.checklist[vself.indited].descricao,
                                                    vself.$store.state.usuario.id, participantes,
                                                    '', '', '', '');
                    }
                    vself.edicaoitemchecklist = false;
                }
            });
            $("#edchecklist").keypress(function(e){
                if(e.wich == 13 || e.keyCode == 13){
                    $("#edchecklist").blur();
                    vself.mtdadicionaritemchecklist();
                }
            });
        },        
        mtdadicionaritemchecklist(){
            let vself = this;
            this.idchecklist++;
            let itemchecklist = {
                'id'                : this.idchecklist,
                'descricao'         : '',
                'idusuariocria'     : this.$store.state.usuario.id,
                'dthrcriacao'       : util.DataAtual(true, true),
                'finalizado'        : 0,
                'dthrfinalizacao'   : '',
                'idusuariofinaliza' : '',
                'edicao'            : 1
            };
            this.checklist.push(itemchecklist);
            this.indited = this.checklist.length - 1;
            setTimeout(function () {
                vself.mtdativametodostext();
                $('#edchecklist').focus();
            },200);            
        },
        mtdeditaritemchecklist(index){
            let vself = this;
            vself.descolditemchecklist    = vself.checklist[index].descricao;
            vself.checklist[index].edicao = 1;
            vself.indited = index;
            vself.edicaoitemchecklist = true;
            setTimeout(function () {
                vself.mtdativametodostext();
                $('#edchecklist').focus();
            },200);
        },
        mtdcarregausuarios(){
            var vself           = this;
            let loader          = this.$loading.show();
            let parametros      = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor : 'listausuarios'},
                {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinatarefas.php');
            retorno.then(function (response) {
                vself.lsttodosusuarios = response.data;
                vself.mtdusuariostarefa(vself.lsttodosusuarios);
                loader.hide();											
            }).catch(function (response) {
                vself.lsttodosusuarios = [];
                loader.hide();
            }); 
        },
        mtdusuariostarefa(listagem){
            let vself               = this;
            let lstusuariostarefa   = [];
            for (let item in listagem) {
                if (listagem.hasOwnProperty(item)) {
                    const element = listagem[item];
                    if (parseInt(element.marcado) === 1){
                        lstusuariostarefa.push(element);
                    }
                }
            }
            vself.lstusuarios   = lstusuariostarefa;
            vself.oplstusuario  = 0;
        },     
        mtdlistartodosusuarios(){            
            this.lstusuarios    = this.lsttodosusuarios;
            this.oplstusuario   = 1;
        },
        mtdmarcarusuario(index) {
            let vself = this;
            if (parseInt(this.optarefa) < 2) {
                let tpat            = 0;
                let texto1          = '';
                let texto2          = '';
                
                let usuario         = [];
                usuario             = vself.lstusuarios[index];

                let participantes   = [];
                if (parseInt(vself.optarefa) === 1) {
                    for (let i = 0; i < vself.lstusuarios.length; ++i) {
                        if (parseInt(vself.lstusuarios[i].marcado) === 1) {
                            let participante = {
                                'idusuario': vself.lstusuarios[i].idusuario,
                                'emailusu' : vself.lstusuarios[i].emailusu
                            };
                            participantes.push(participante);
                        }
                    }
                }
                if (parseInt(this.lstusuarios[index].marcado) === 0) {
                    this.lstusuarios[index].marcado = 1;
                    //registra ação de adicionar usuário a tarefa
                    texto1 = 'Adicionou o usuário';
                    tpat = 5;
                } else {
                    if (parseInt(this.lstusuarios[index].idusuario) !== parseInt(vself.$store.state.usuario.id)) {
                        this.lstusuarios[index].marcado = 0;
                        //registra ação de excluir o usuário da tarefa
                        texto1 = 'Removeu o usuário';
                        tpat = 6;
                    } else {
                        return;
                    }
                }
                if (parseInt(vself.optarefa) === 1) {
                    vself.mtdregistraratividade(vself.tarefaold.id, tpat,
                                                texto1, texto2, usuario.idusuario, usuario.nomeusu, 
                                                vself.$store.state.usuario.id, participantes,
                                                '', '', '', '');
                }
            }
        },
        mtddisparabtenviarquivotarefa() {
            const file               = document.querySelector('#btenviararquivotarefa');
            file.value               = '';
            $('#btenviararquivotarefa').trigger('click');
        },
        mtdenviararquivo(){
            let vself               = this;
            let loader              = vself.$loading.show();
            vself.arqselecionado    = document.getElementById("btenviararquivotarefa").files[0];
            let nomearquivo         = vself.arqselecionado.name;            
            let localsalvar         = vself.$store.state.configpaths.pathtarefas + vself.$store.state.filialpadrao.idcliente +'/'+ vself.diretoriotarefa;

            let participantes = [];
            for (let i = 0; i < vself.lstusuarios.length; ++i) {
                if (parseInt(vself.lstusuarios[i].marcado) === 1) {
                    let participante = {
                        'idusuario' : vself.lstusuarios[i].idusuario,
                        'emailusu'  : vself.lstusuarios[i].emailusu
                    };
                    participantes.push(participante);
                }
            }

            let registro = {
                'idtarefa'      : vself.tarefaold.id,
                'tpatividade'   : 15,
                'descricao1'    : 'Enviou arquivo',
                'descricao2'    : nomearquivo,
                'iditem'		: '', //Pode ser o usuário adicionado ou removido da tarefa ou o id da checklist.
                                          //Quando for alteração do título, data ou descritivo passsar 0(zero) como parâmetro
                'descitem'      : '',//Nome do usuário ou descrição do ítem da checklist

                'idusuario'     : vself.$store.state.usuario.id, //Código do usuário que registrou a atividade
                'titulo'        : '',
                'dttarefa'      : '',
                'detalhes'      : '',
                'participantes' : participantes, // participantes para enviar o e-mail informando o registro da atividade
                'mensagem'      : ''				
            };

            let parametros      = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',               valor  : 'uploadarquivo'},     
                {parametro: 'registro',         valor  : JSON.stringify(registro)},
                {parametro: 'idusuario',        valor  : vself.$store.state.usuario.id},
                {parametro: 'arquivo',          valor  : vself.arqselecionado},
                {parametro: 'localsalvar',      valor  : localsalvar},
                {parametro: 'nomearquivo',      valor  : vself.arqselecionado.name}
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinatarefas.php');
            retorno.then(function (response) {
                if ($.isNumeric(response.data.inf)){
                    vself.$toastr.s('Arquivo enviado com sucesso!', 'Informação!');
                    vself.comentario          = '';
                    vself.lstatividadestarefa = response.data.atividades;
                    vself.lstarquivostarefa   = response.data.arquivos;
                    vself.arqselecionado      = null;
                    $('#btenviararquivotarefa').val('');
                }else{
                    let tpret = response.data.inf.substring(0,1);
                    switch (tpret) {
                        case 'I':
                            vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
                            break;
                        case 'E': default:
                            vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                            break;
                    }
                    $("#mdltarefa").modal('hide');
                }
                loader.hide();
            }).catch(function (response) {
                loader.hide();
                vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
            });            
        },
        mtddeletararquivo(patharquivo, nomearquivo){
            let vself           = this;
            let localarquivo    =   vself.$store.state.configpaths.pathtarefas + 
                                    vself.$store.state.filialpadrao.idcliente +'/'+
                                    vself.diretoriotarefa;            
            let loader          = vself.$loading.show();
            
            let participantes = [];
            for (let i = 0; i < vself.lstusuarios.length; ++i) {
                if (parseInt(vself.lstusuarios[i].marcado) === 1) {
                    let participante = {
                        'idusuario' : vself.lstusuarios[i].idusuario,
                        'emailusu'  : vself.lstusuarios[i].emailusu
                    };
                    participantes.push(participante);
                }
            }

            let registro = {
                'idtarefa'      : vself.tarefaold.id,
                'tpatividade'   : 16,
                'descricao1'    : 'Excluiu arquivo',
                'descricao2'    : nomearquivo,
                'iditem'		: '', //Pode ser o usuário adicionado ou removido da tarefa ou o id da checklist.
                                          //Quando for alteração do título, data ou descritivo passsar 0(zero) como parâmetro
                'descitem'      : '',//Nome do usuário ou descrição do ítem da checklist

                'idusuario'     : vself.$store.state.usuario.id, //Código do usuário que registrou a atividade
                'titulo'        : '',
                'dttarefa'      : '',
                'detalhes'      : '',
                'participantes' : participantes, // participantes para enviar o e-mail informando o registro da atividade
                'mensagem'      : '',
				
            };
            let parametros      = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor : 'excluirarquivo'},
                {parametro: 'patharquivo',  valor  : patharquivo},
                {parametro: 'localarquivo', valor  : localarquivo},				
                {parametro: 'registro',     valor : JSON.stringify(registro)},
                {parametro: 'idusuario',    valor : vself.$store.state.usuario.id}
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinatarefas.php');
            retorno.then(function (response) {
                loader.hide();
                if ($.isNumeric(response.data.inf)){
                    vself.$toastr.s('Arquivo excluído com sucesso!', 'Informação!');
                    vself.comentario          = '';
                    vself.lstatividadestarefa = response.data.atividades;
                    vself.lstarquivostarefa   = response.data.arquivos;
                }else{
                    let tpret = response.data.inf.substring(0,1);
                    switch (tpret) {
                        case 'I':
                            vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
                            break;
                        case 'E': default:
                            vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                            break;
                    }
                    $("#mdltarefa").modal('hide');
                }
            }).catch(function (response) {
                loader.hide();
                vself.$toastr.e('Erro ao tentar excluir o arquivo. Descrição do erro: '+response.message, 'Erro!');
                $("#mdltarefa").modal('hide');
            });                                                             
        },         
        mtdincluirtarefa(){
            let vself  = this;

            if (vself.titulotarefa === ''){
                vself.$toastr.w('Título da tarefa deve ser informado!', 'Atenção!');
                $('#edtitulotarefa').focus();
                return;
            }

            if (vself.dttarefa === null){
                vself.$toastr.w('Data da tarefa deve ser informada!', 'Atenção!');
                $('#eddttarefa').focus();
                return;
            }

            let loader = vself.$loading.show(); 

            vself.mtdusuariostarefa(vself.lsttodosusuarios);//lista só os usuários participantes da tarefa

            let tarefa = {
                'titulo'            : vself.titulotarefa,
                'detalhes'          : vself.descritivotarefa,
                'idusuario'		    : vself.$store.state.usuario.id,
                'dttarefa'          : vself.dttarefa,
                'iddiretoriocliente': vself.$store.state.filialpadrao.idcliente,
                'diretorioarquivos' : vself.diretoriotarefa,
                'checklist'         : vself.checklist,
                'participantes'     : vself.lstusuarios
            };
            let parametros      = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor : 'incluirtarefa'},
                {parametro: 'tarefa',       valor : JSON.stringify(tarefa)},
                {parametro: 'idusuario',    valor : vself.$store.state.usuario.id}
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinatarefas.php');
            retorno.then(function (response) {
                loader.hide();
                if ($.isNumeric(response.data)){
                    vself.$toastr.s('Tarefa registrada com sucesso!', 'Informação!');
                    $('#mdltarefa').modal('hide');
                    //listar tarefas do usuário
                }else{
                    let tpret = response.data.substring(0,1);
                    switch (tpret) {
                        case 'I':
                            vself.$toastr.w(response.data.substring(4), 'Atenção!');
                            break;
                        case 'E': default:
                            vself.$toastr.e(response.data.substring(4), 'Erro!');
                            break;
                    }
                }
            }).catch(function (response) {
                loader.hide();
                vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
            });
        },
        mtdsituacaoitemchecklist(index) {
            let vself  = this;
            let tpat   = 0;
            let texto1 = '';
            if (parseInt(vself.checklist[index].finalizado) === 0){
                tpat    = 10;
                vself.checklist[index].finalizado        = 1;
                vself.checklist[index].dthrfinalizacao   = util.DataAtual(true, true);
                vself.checklist[index].codusufinaliza    = vself.$store.state.usuario.id;
                texto1 = 'Finalizou item da Checklist';
            }else{
                tpat    = 11;
                vself.checklist[index].finalizado        = 0;
                vself.checklist[index].dthrfinalizacao   = '';
                vself.checklist[index].codusufinaliza    = '';
                texto1 = 'Desfez finalização de item da Checklist';
            }
            if (parseInt(vself.optarefa) === 1) {
                let participantes = [];
                for (let i = 0; i < vself.lstusuarios.length; ++i) {
                    if (parseInt(vself.lstusuarios[i].marcado) === 1) {
                        let participante = {
                            'idusuario' : vself.lstusuarios[i].idusuario,
                            'emailusu'  : vself.lstusuarios[i].emailusu
                        };
                        participantes.push(participante);
                    }
                }
                vself.mtdregistraratividade(vself.tarefaold.id, tpat,
                                            texto1,
                                            '', vself.checklist[index].id, 
                                            vself.checklist[index].descricao, 
                                            vself.$store.state.usuario.id, participantes,
                                            '', '', '', '');               
            }
        },        
        mtdexcluiritemchecklist(index) {
            let vself = this;
            if (parseInt(vself.optarefa) === 1) {
                let participantes = [];
                for (let i = 0; i < vself.lstusuarios.length; ++i) {
                    if (parseInt(vself.lstusuarios[i].marcado) === 1) {
                        let participante = {
                            'idusuario' : vself.lstusuarios[i].idusuario,
                            'emailusu'  : vself.lstusuarios[i].emailusu
                        };
                        participantes.push(participante);
                    }
                }
                vself.mtdregistraratividade(vself.tarefaold.id, 9,
                                            'Excluiu item da Checklist',
                                            '', vself.checklist[index].id, vself.checklist[index].descricao, 
                                            vself.$store.state.usuario.id, participantes, '', '', '', '');
            }
            vself.checklist.splice(index, 1);
        },        
        mtdcarregadadostarefa(){
            var vself           = this;
            vself.pathfotos     = vself.$store.state.configpaths.pathimagens;
            vself.patharquivos  = vself.$store.state.configpaths.patharquivos;
            vself.pathtarefas   = vself.$store.state.configpaths.pathtarefas;           
            let loader          = vself.$loading.show();
            let parametros      = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor : 'dadostarefa'},
                {parametro: 'filtrotarefas',valor : ' and t.id='+vself.idtarefa},
                {parametro: 'patharquivos', valor : vself.pathtarefas},
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinatarefas.php');
            retorno.then(function (response) {
                if (response.data.length > 0){
                    vself.tarefaold           = response.data[0]; 
                    vself.titulotarefa        = vself.tarefaold.titulo;
                    vself.dttarefa            = vself.tarefaold.dttarefa;
                    vself.descritivotarefa    = vself.tarefaold.detalhes;
                    vself.checklist           = vself.tarefaold.checklist;
                    vself.lsttodosusuarios    = vself.tarefaold.participantes;
                    vself.lstarquivostarefa   = vself.tarefaold.arquivos;
                    vself.lstatividadestarefa = vself.tarefaold.atividades;
                    vself.diretoriotarefa     = vself.tarefaold.diretorioarquivos;
                    vself.dttarefaold         = vself.tarefaold.dttarefa;

                    if (vself.checklist.length > 0) {
                        vself.idchecklist = vself.checklist[vself.checklist.length - 1].id;
                    }else{
                        vself.idchecklist = 1;
                    }                    
                    vself.mtdusuariostarefa(vself.lsttodosusuarios);
                    if (parseInt(vself.tarefaold.sttarefa) === 1){
                        vself.optarefa = 2;
                    }
                }else{
                    vself.$toastr.w('Tarefa não localizada. Favor tentar novamente mais tarde!', 'Atenção!');
                    $('#mdltarefa').modal('hide');
                }                
                loader.hide();											
            }).catch(function (response) {
                vself.lstresultadofaturamento = [];
                loader.hide();
            });
        },
        mtdregistraratividade(idtarefa, tpatividade, texto1, texto2, iditem, descitem, idusuario, participantes, titulo, dttarefa, detalhes, mensagem) {
            let vself  = this;
            let loader = vself.$loading.show(); 
            //Códigos para o tpatividade
            //1 - criar tarefa
            //2 - alterar título
            //3 - alterar data
            //4 - alterar detalhes
            //5 - Adicionar participante
            //6 - Remover participante
            //7 - Adicionar item checklist
            //8 - Alterar item checklist
            //9 - Excluir item checklist
            //10- Finalizar item checklist
            //11- Desfaz finalização do item da check list
            //12- Finalizar tarefa
            //13- Registar comentário
            //14- Reativar tarefa
            let registro = {
                'idtarefa'      : idtarefa,
                'tpatividade'   : tpatividade,
                'descricao1'    : texto1,
                'descricao2'    : texto2,
                'iditem'		: iditem, //Pode ser o usuário adicionado ou removido da tarefa ou o id da checklist.
                                          //Quando for alteração do título, data ou descritivo passsar 0(zero) como parâmetro
                'descitem'      : descitem,//Nome do usuário ou descrição do ítem da checklist

                'idusuario'     : idusuario, //Código do usuário que registrou a atividade
                'titulo'        : titulo,
                'dttarefa'      : dttarefa,
                'detalhes'      : detalhes,
                'participantes' : participantes, // participantes para enviar o e-mail informando o registro da atividade
                'mensagem'      : mensagem
            };
            let parametros      = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor : 'registraratividade'},
                {parametro: 'registro',     valor : JSON.stringify(registro)},
                {parametro: 'idusuario',    valor : vself.$store.state.usuario.id}
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinatarefas.php');
            retorno.then(function (response) {
                loader.hide();
                if ($.isNumeric(response.data.inf)){
                    vself.$toastr.s('Atividade registrada com sucesso!', 'Informação!');
                    vself.comentario          = '';
                    vself.tarefaold.titulo    = vself.titulotarefa;
                    vself.dttarefaold         = vself.dttarefa;                    
                    vself.tarefaold.detalhes  = vself.descritivotarefa;
                    vself.lstatividadestarefa = response.data.atividades;
                    if (parseInt(tpatividade) === 14){//reativação da tarefa
                        vself.optarefa = 1;
                    }else if(parseInt(tpatividade) === 12){//finaliza a tarefa
                        vself.optarefa = 2;
                    }
                }else{
                    let tpret = response.data.inf.substring(0,1);
                    switch (tpret) {
                        case 'I':
                            vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
                            break;
                        case 'E': default:
                            vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                            break;
                    }
                    $("#mdltarefa").modal('hide');
                }                
            }).catch(function (response) {
                loader.hide();
                vself.$toastr.e('Erro ao tentar registrar a atividade. Descrição do erro: '+response.message, 'Erro!');
                $("#mdltarefa").modal('hide');
            });
        },
        mtdatividadedata(){
            let vself = this;
            if (parseInt(vself.optarefa) === 1) {
                if (vself.dttarefaold !== vself.dttarefa) {
                    let participantes = [];
                    for (let i = 0; i < vself.lstusuarios.length; ++i) {
                        if (parseInt(vself.lstusuarios[i].marcado) === 1) {
                            let participante = {
                                'idusuario' : vself.lstusuarios[i].idusuario,
                                'emailusu'  : vself.lstusuarios[i].emailusu
                            };
                            participantes.push(participante);
                        }
                    }
                    vself.mtdregistraratividade(vself.tarefaold.id, 3,
                        'Alterou data ' + vself.dttarefaold,
                        vself.dttarefa, 0, '', vself.$store.state.usuario.id, participantes,
                        vself.titulotarefa, vself.dttarefa, '','');
                }
            }
        },                          
        mtdatividadetitulo(){
            let vself = this;
            if (parseInt(vself.optarefa) === 1) {
                if (vself.tarefaold.titulo !== vself.titulotarefa) {
                    let participantes = [];
                    for (let i = 0; i < vself.lstusuarios.length; ++i) {
                        if (parseInt(vself.lstusuarios[i].marcado) === 1) {
                            let participante = {
                                'idusuario' : vself.lstusuarios[i].idusuario,
                                'emailusu'  : vself.lstusuarios[i].emailusu
                            };
                            participantes.push(participante);
                        }
                    }
                    vself.mtdregistraratividade(vself.tarefaold.id, 2,
                                                'Alterou título da tarefa ' + vself.tarefaold.titulo,
                                                vself.titulotarefa, 0, '', vself.$store.state.usuario.id, participantes,
                                                vself.titulotarefa, '', '', '');
                }
            }
        },
        mtdatividadedetalhes(){
            let vself = this;
            if (parseInt(vself.optarefa) === 1) {
                if (vself.tarefaold.detalhes !== vself.descritivotarefa) {
                    let participantes = [];
                    for (let i = 0; i < vself.lstusuarios.length; ++i) {
                        if (parseInt(vself.lstusuarios[i].marcado) === 1) {
                            let participante = {
                                'idusuario' : vself.lstusuarios[i].idusuario,
                                'emailusu'  : vself.lstusuarios[i].emailusu
                            };
                            participantes.push(participante);
                        }
                    }
                    vself.mtdregistraratividade(vself.tarefaold.id, 4,
                        'Alterou detalhes da tarefa ' + vself.tarefaold.titulo,
                        '', 0, '', vself.$store.state.usuario.id, participantes,
                        '', '', vself.descritivotarefa, vself.tarefaold.detalhes)
                }
            }            
        },
        mtdenviarcomentario(){
            let vself = this;
            if (vself.comentario.trim() === ''){
                msgnotif("Comentário deve ser informado!", 'Informação', 'info', 'toast-top-right');
                $('#txtcomentario').focus();
                return;
            }
            let participantes = [];
            for (let i = 0; i < vself.lstusuarios.length; ++i) {
                if (parseInt(vself.lstusuarios[i].marcado) === 1) {
                    let participante = {
                        'idusuario' : vself.lstusuarios[i].idusuario,
                        'emailusu'  : vself.lstusuarios[i].emailusu
                    };
                    participantes.push(participante);
                }
            }
            vself.mtdregistraratividade(vself.tarefaold.id, 13,
                                        'Enviou comentário',
                                        '', '', '', vself.$store.state.usuario.id, participantes,
                                        '', '', '', vself.comentario);
        },
        mtdfinalizartarefa(){
            let vself = this;
            $.confirm({
                title: 'Confirmação!',
                content: 'Confirma <span class="text-info" style="font-weight: 500">finalização</span> da tarefa?',
                icon: 'fa fa-question-circle',
                escapeKey: true,
                backgroundDismiss: false,
                escapeKey: 'nao',
                type: 'dark',
                typeAnimated: true,
                buttons: {
                    sim: {
                        text: '<u>S</u>im',
                        keys: ['s', 'S'],
                        btnClass: 'btn-blue',
                        action: function () {
                            $('.btn-blue').prop('disabled', true);
                            let participantes = [];
                            for (let i = 0; i < vself.lstusuarios.length; ++i) {
                                if (parseInt(vself.lstusuarios[i].marcado) === 1) {
                                    let participante = {
                                        'idusuario' : vself.lstusuarios[i].idusuario,
                                        'emailusu'  : vself.lstusuarios[i].emailusu
                                    };
                                    participantes.push(participante);
                                }
                            }
                            vself.mtdregistraratividade(vself.tarefaold.id, 12,
                                                        'Finalizou a tarefa',
                                                        '', '', '', vself.$store.state.usuario.id,
                                                        participantes, '', '', '', '');
                        },
                    },
                    nao: {
                        text: '<u>N</u>ão',
                        keys: ['n', 'N'],
                        action: function () {
                        }
                    }
                }
            });
        },
        mtdreativartarefa(){
            let vself = this;
            let participantes = [];
            for (let i = 0; i < vself.lstusuarios.length; ++i) {
                if (parseInt(vself.lstusuarios[i].marcado) === 1) {
                    let participante = {
                        'idusuario' : vself.lstusuarios[i].idusuario,
                        'emailusu'  : vself.lstusuarios[i].emailusu
                    };
                    participantes.push(participante);
                }
            }
            vself.mtdregistraratividade(vself.tarefaold.id, 14,
                                        'Reativou a tarefa',
                                        '', '', '', vself.$store.state.usuario.id, participantes,
                                        '', '', '', '');
        } 
    },
    mounted: function () {         
        let vself = this;

        vself.pathfotos           = vself.$store.state.configpaths.pathimagens;
        vself.patharquivos        = vself.$store.state.configpaths.patharquivos;
        vself.pathtarefas         = vself.$store.state.configpaths.pathtarefas;

        $("#mdltarefa").on('shown.bs.modal', function () {
            if (parseInt(vself.optarefa) === 0){
                $('#edtitulotarefa').focus();
            }
        });
        $("#mdltarefa").on('hide.bs.modal', function () {
            let payload = {
                abrirtela    : false
            };
            vself.$store.commit('ROTINA_TAREFAS_CHANGE',payload);            
        });             
        $("#edtitulotarefa").blur(function(){
            vself.mtdatividadetitulo();
        });    
        $("#eddttarefa").blur(function(){
            vself.mtdatividadedata();
        });    
        $("#txtdescritivotarefa").blur(function(){
            vself.mtdatividadedetalhes();
        });    
    },    
    computed:{
        abrirtela(){
            return this.$store.state.rotinatarefas.abrirtela;                
        }        
    },
    watch:{
        abrirtela(val){
            let vself = this; 
            vself.pathfotos     = vself.$store.state.configpaths.pathimagens;
            vself.patharquivos  = vself.$store.state.configpaths.patharquivos;
            vself.pathtarefas   = vself.$store.state.configpaths.pathtarefas;                       
            if (val){
                $('#mdltarefa').modal('show');
                vself.optarefa = vself.optarefacmp;
                vself.idtarefa = vself.idtarefacmp;
                if (parseInt(vself.optarefa) === 0){//prepara a tela para inclusão de uma nova tarefa                    
                    vself.mtdcarregausuarios();
                    vself.oplstusuario        = 0;
                    vself.diretoriotarefa     = util.GerarStringAleatoria();
                    vself.titulotarefa        = '';
                    vself.dttarefa            = util.DataAtual(true);
                    vself.descritivotarefa    = '';
                    vself.comentario          = '';                    
                    vself.idchecklist         = 0;
                    vself.checklist           = [];
                    vself.lstatividadestarefa = [];
                    vself.lstarquivostarefa   = [];

                    vself.arqselecionado      = null;

                    vself.indited             = 0;
                    vself.tarefaold           = [];
                    vself.dttarefaold         = util.DataAtual(true); 
                }else{//iguala os dados da tarefa para as alterações
                    vself.mtdcarregadadostarefa();
                }
            }else{					
                $('#mdltarefa').modal('hide');
            }
        }
    }    
}
</script>
<style>
    .optask-list{
        cursor: pointer;
        padding: 5px 15px 5px 15px!important;
    }
    .optask-list:hover #edchecklist{
        background: #F8F9FA;
    }
    .tit-checklist{
        padding-top: 2px;
        font-size: 12px;
        color: #666;
    }
    .link-add{
        text-decoration: none;
        cursor: pointer;
        color: #57AEF1;
    }
    .link-add:hover{
        color: #5292d0;
    }
    .bt-op-tarefa{
        position: absolute;
        color: #a6a6a6;
        font-size: 22px;
        left: 5px;
    }
    .bt-exc-tarefa {
        float: right;
        color: #a6a6a6;
        font-size: 22px;
    }
    .bt-op-tarefa:hover{
        color: #6B6B6B;
    }
    .bt-exc-tarefa:hover{
        color: #6B6B6B;
    }
    #edchecklist{
        width: 100%;
        min-height: 70px;
        border: 0px;
        font-size: 14px;
    }
    #edchecklist:focus{
        box-shadow: 0 0 0 0;
        border: 0 none;
        outline: 0;
    }
    .btn-participantes{
        font-size: 12px!important;
        width: 20px!important;
        height: 20px!important;
        padding: 0px!important;
        margin-top: -5px;
    }
    .icone-atividade{
        margin: 50%;
        font-size: 25px;
    }
    .tit-atividade{
        font-size: 12px;
        color: #a2a2a2;
        margin-bottom: 0px;
    }
    .det-dthratividade{
        font-size: 10px;
        color: #a2a2a2;
        margin-bottom: 0px;
    }
    .det-atividade{
        font-size: 12px;
        color: #a2a2a2;
        margin-bottom: 0px;
    }
    .card-comentario{
        margin-top: 2px;
        margin-right: 25px;
        flex-grow: 1;
        flex-shrink: 1;
        padding-left: 12px;
        border-radius: 5px;
        position: relative;
        background-color: rgb(247, 249, 250);
        box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 1px 0px;
        margin-bottom: 2px;
    }
    .corpo-comentario{
        font-size: 14px;
        color: #a2a2a2;
    }        
</style>